// import React, { useEffect, useState } from "react";
// import { toast } from "react-toastify";

// import { apiGet, apiPost, apiPut } from "../Utils/apiFetch";
// import { apiPath } from "../Utils/apiPath";
// import { formatDate } from "../Utils/Constant";
// import AuthContext from "../context/AuthContext";
// import { useContextSelector } from "use-context-selector";
// import UpdateDialogBox from "./User/UpdateDialogBox";

// const SPORT_OPTIONS = [
//   { id: "All", value: "all", label: "All" },
//   { id: "events_1", value: 1, label: "Soccer" },
//   { id: "events_2", value: 2, label: "Tennis" },
//   { id: "events_4", value: 4, label: "Cricket" },
// ];

// const TABS = [
//   { id: "reportType_sportsBook", label: "Import", status: "import" },
//   { id: "reportType_exchange", label: "Inplay", status: "in_play" },
//   { id: "reportType_casino", label: "Upcoming", status: "active" },
// ];

// const MM = () => {
//   const user = useContextSelector(AuthContext, (ctx) => ctx.user);

//   const [tab, setTab] = useState("in_play");
//   const [filter, setFilter] = useState({ eventType: "all", status: "in_play" });
//   const [keyword, setKeyword] = useState("");
//   const [data, setData] = useState([]);
//   const [openId, setOpenId] = useState("");
//   const [openMarketId, setOpenMarketId] = useState("");

//   const [blockMatchStatus, setBlockMatchStatus] = useState(false);
//   const [sportsListingUpdateId, setSportsListingUpdateId] = useState({});
//   const [isLoader, setLoader] = useState(false);

//   const getData = async (overrideFilter) => {
//     const finalFilter = overrideFilter || filter;
//     const params = {
//       ...finalFilter,
//       hasMatchOdds: true,
//       keyword,
//     };
//     if (params.eventType === "all") {
//       delete params.eventType;
//     }

//     const { status, data: response_users } = await apiGet(
//       apiPath.matchFilterList,
//       params,
//     );
//     if (status === 200 && response_users.success) {
//       setData(response_users.results || []);
//       setOpenId("");
//       setOpenMarketId("");
//     }
//   };

//   useEffect(() => {
//     getData();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const handleTabChange = (tabDef) => {
//     setTab(tabDef.status);
//     const nextFilter = { ...filter, status: tabDef.status };
//     setFilter(nextFilter);
//     getData(nextFilter);
//   };

//   const handleSportChange = (value) => {
//     const nextFilter = { ...filter, eventType: value };
//     setFilter(nextFilter);
//     getData(nextFilter);
//   };

//   const toggleExpand = (id) => setOpenId((prev) => (prev === id ? "" : id));

//   const toggleMarket = (marketId) =>
//     setOpenMarketId((prev) => (prev === marketId ? "" : marketId));
//   const nextOnOff = (item) => (item?.matchOdds == "on" ? "off" : "on");

//   const openMatchOnOff = (item) => {
//     setSportsListingUpdateId({
//       eventId: item?.eventId,
//       marketId: item?.marketId,
//       status: nextOnOff(item),
//       type: "matchOnOff",
//     });
//     setBlockMatchStatus(true);
//   };

//   const openMatchConfirm = (item) => {
//     setSportsListingUpdateId({
//       eventId: item?.eventId,
//       marketId: item?.marketId,
//       status: tab === "import" ? "on" : "off",
//       type: "matchOnOff",
//     });
//     setBlockMatchStatus(true);
//   };
//   const openMarketConfirm = (item) => {
//     if (tab === "import") {
//       openMatchOnOff(item);
//       return;
//     }
//     // old project's toggle logic operates per-selection (SelectionId); this
//     // page's markup groups the switch at the market level instead, so this
//     // toggles the whole market without a specific SelectionId
//     setSportsListingUpdateId({
//       matchOdds: item?.matchOdds == "on" ? "off" : "on",
//       eventId: item?.eventId,
//       marketId: item?.marketId,
//       status: item?.matchOdds == "on" ? "off" : "on",
//       type: "matchOdds",
//     });
//     setBlockMatchStatus(true);
//   };

//   const closeConfirm = () => {
//     setBlockMatchStatus(false);
//     setSportsListingUpdateId({});
//   };
//   const confirmToggle = async () => {
//     setLoader(true);
//     try {
//       const updateType = sportsListingUpdateId?.type;
//       const path =
//         updateType === "match"
//           ? apiPath.updateSportsListingStatus + `/${sportsListingUpdateId?.id}`
//           : updateType === "matchOnOff"
//             ? apiPath.updateMatchOddsListingStatus
//             : apiPath.updateBlockListinStatus;
//       const payload =
//         updateType === "matchOnOff"
//           ? {
//               eventId: sportsListingUpdateId?.eventId,
//               marketId: sportsListingUpdateId?.marketId,
//               status: sportsListingUpdateId?.status,
//             }
//           : updateType === "match"
//             ? { status: sportsListingUpdateId?.status }
//             : {
//                 eventId: sportsListingUpdateId?.eventId,
//                 matchOdds: sportsListingUpdateId?.matchOdds,
//                 marketId: sportsListingUpdateId?.marketId,
//               };

//       const { status, data: response_users } = await (
//         updateType === "matchOdds" ? apiPost(path, payload) : apiPut(path, payload)
//       );


//       if (status === 200 && response_users.success) {
//         toast.success(response_users.message);
//         getData();
//       } else {
//         toast.error(response_users.message);
//       }
//     } catch (err) {
//       toast.error(err?.response?.data?.message);
//     } finally {
//       setLoader(false);
//       closeConfirm();
//     }
//   };

//   const rows = data || [];

//   return (
//     <app-events>
//       <div style={{ width: "99%" }} className="main_wrap">
//         <ul className="report-tab-wrap" style={{ display: "flex" }}>
//           {TABS.map((t) => (
//             <li
//               key={t.id}
//               id={t.id}
//               className={`report-tab ${tab === t.status ? "select" : ""}`}
//               onClick={() => handleTabChange(t)}
//               style={{ cursor: "pointer" }}
//             >
//               {" "}
//               {t.label}{" "}
//             </li>
//           ))}
//           <li className="spacer" />
//           <li className="web users-info">
//             <span> Online Users 0 </span>
//             <span className="separator"> | </span>
//             <span> Total Users: 0 </span>
//           </li>
//         </ul>
//         <div className="function-wrap">
//           <ul className="input-list contentclass">
//             <li id="eventRadioBtnList" className="eventRadioBtnList">
//               {SPORT_OPTIONS.map((opt) => (
//                 <React.Fragment key={opt.id}>
//                   <input
//                     type="radio"
//                     name="events"
//                     id={opt.id}
//                     checked={filter.eventType === opt.value}
//                     onChange={() => handleSportChange(opt.value)}
//                   />
//                   <label htmlFor={opt.id}>{opt.label}</label>
//                 </React.Fragment>
//               ))}
//             </li>
//             <li>
//               <div id="userSearchUl" className="search-wrap">
//                 <input
//                   type="text"
//                   name="userId"
//                   id="userId"
//                   className="search-input"
//                   placeholder="Search Events, Tournaments"
//                   value={keyword}
//                   onChange={(e) => setKeyword(e.target.value)}
//                 />
//                 <button
//                   id="searchUserId"
//                   className="search-but"
//                   onClick={() => getData()}
//                 >
//                   {" "}
//                   Search{" "}
//                 </button>
//               </div>
//             </li>
//             <li className="spacer" />
//             <li className="import-button">
//               <button className="btn-send" onClick={() => getData()}>
//                 Refresh
//               </button>
//             </li>
//           </ul>
//         </div>
//       </div>
//       <div style={{ width: "99%" }} className="main_wrap">
//         <div className="table-responsive data-table" />
//         <div className="table-responsive data-table">
//           <table id="table_DL" className="table01 table-pt">
//             <tbody>
//               <tr id="head">
//                 <th width="2%" className="align-C">
//                   <input type="checkbox" name="select_all" id="select_all" />
//                 </th>
//                 <th id="market_info" className="align-C">
//                   Market Info
//                 </th>
//                 <th width="5%" className="align-C">
//                   Status
//                 </th>
//                 <th width="5%" className="align-C">
//                   TV
//                 </th>
//                 <th width="5%" className="align-C">
//                   Time
//                 </th>
//                 <th width="8%" className="align-C">
//                   User Online
//                 </th>
//                 <th width="8%" className="align-C">
//                   No of bets
//                 </th>
//               </tr>
//             </tbody>
//             <tbody id="content">
//               {rows.length > 0 ? (
//                 rows.map((item) => {
//                   const isOpen = openId === item?._id;
//                   const marketId = `${item?._id}_0`;
//                   const isMarketOpen = openMarketId === marketId;
//                   return (
//                     <React.Fragment key={item?._id}>
//                       <tr id={`event_${item?._id}`}>
//                         <td className="align-C">
//                           <input type="checkbox" name="select" id="select" />
//                         </td>
//                         <td className="align-L">
//                           <a
//                             className={isOpen ? "expand-open" : "expand-close"}
//                             style={{ cursor: "pointer" }}
//                             onClick={() => toggleExpand(item?._id)}
//                           />{" "}
//                           {item?.eventName} <b> - [ {item?.seriesName} ]</b>
//                         </td>
//                         <td className="align-C" id={`status_${item?._id}`}>
//                           <label className="xyz">
//                             <input
//                               type="checkbox"
//                               checked={tab !== "import"}
//                               readOnly
//                               onClick={() => openMatchConfirm(item)}
//                             />
//                             <span className="slider round" />
//                           </label>
//                         </td>
//                         <td className="align-C" id={`tv_${item?._id}`}>
//                           <span className="green">
//                             <i className="fa fa-television" />
//                           </span>
//                         </td>
//                         <td className="align-C" id={`time_${item?._id}`}>
//                           <span className="red">
//                             {formatDate(
//                               item?.eventDateTime,
//                               user?.timeZone,
//                             )}{" "}
//                           </span>
//                         </td>
//                         <td className="align-C" id={`user_online_${item?._id}`}>
//                           {" "}
//                           0{" "}
//                         </td>
//                         <td className="align-C" id={`no_bet_${item?._id}`}>
//                           {" "}
//                           0{" "}
//                         </td>
//                       </tr>

//                       <tr
//                         className="expand first"
//                         style={{ display: isOpen ? "table-row" : "none" }}
//                         id={`sub_${item?._id}`}
//                       >
//                         <td />
//                         <td colSpan={14}>
//                           <div className="market">
//                             <a
//                               className={
//                                 isMarketOpen ? "expand-open" : "expand-close"
//                               }
//                               style={{ cursor: "pointer" }}
//                               onClick={() => toggleMarket(marketId)}
//                             />{" "}
//                             {item?.market} <span className="spacer" />
//                             <label className="xyz">
//                               <input
//                                 type="checkbox"
//                                 checked={item?.matchOdds == 'on' ? true : false}
//                                 readOnly
//                                 onClick={() => openMarketConfirm(item)}
//                               />
//                               <span className="slider round" />
//                             </label>
//                           </div>
//                           <div
//                             className="markets"
//                             style={{ display: isMarketOpen ? "flex" : "none" }}
//                             id={`market_${item?._id}_0`}
//                           >
//                             {item?.jsonData?.length > 0 ? (
//                               item.jsonData.map((res, i) => (
//                                 <div
//                                   className="market sub_market"
//                                   key={res?.SelectionId || i}
//                                 >
//                                   {" "}
//                                   {res?.RunnerName} <span className="spacer" />
//                                   <span className="odds-display">
//                                     <div
//                                       className="w-4/12 relative grid gap-0.5 grid-cols-2"
//                                       style={{
//                                         display: "flex",
//                                         marginRight: "10px",
//                                       }}
//                                     >
//                                       <div
//                                         title="back"
//                                         className="py-1.5 h-36px text-center bg-back-300 back-1 animate-spark-back"
//                                         style={{
//                                           backgroundColor: "#a7d8fd",
//                                           padding: "5px",
//                                           width: "50px",
//                                         }}
//                                       >
//                                         <span
//                                           className="text-15 pb-0.5"
//                                           style={{
//                                             paddingBottom: "0.125rem",
//                                             fontWeight: "600",
//                                           }}
//                                         >
//                                           {" "}
//                                           -
//                                         </span>
//                                         <p
//                                           className="text-9"
//                                           style={{
//                                             fontSize: ".6428571429rem",
//                                             marginBottom: "0px",
//                                           }}
//                                         >
//                                           {" "}
//                                           -{" "}
//                                         </p>
//                                       </div>
//                                       <div
//                                         title="back"
//                                         className="py-1.5 h-36px text-center bg-back-300 back-1 animate-spark-back"
//                                         style={{
//                                           backgroundColor: "#f9c9d4",
//                                           padding: "5px",
//                                           width: "50px",
//                                         }}
//                                       >
//                                         <span
//                                           className="text-15 pb-0.5"
//                                           style={{
//                                             paddingBottom: "0.125rem",
//                                             fontWeight: "600",
//                                           }}
//                                         >
//                                           {" "}
//                                           -
//                                         </span>
//                                         <p
//                                           className="text-9"
//                                           style={{
//                                             fontSize: ".6428571429rem",
//                                             marginBottom: "0px",
//                                           }}
//                                         >
//                                           {" "}
//                                           -{" "}
//                                         </p>
//                                       </div>
//                                     </div>
//                                   </span>
//                                   <button className="btn">
//                                     <i
//                                       aria-hidden="true"
//                                       className="fa fa-plus-circle"
//                                     />
//                                   </button>
//                                 </div>
//                               ))
//                             ) : (
//                               <div className="market sub_market">
//                                 No selections found
//                               </div>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     </React.Fragment>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan={7}>No events found.</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//         <div className="table-responsive data-table" />
//         <div className="table-responsive data-table" />
//       </div>

//       <UpdateDialogBox
//         open={blockMatchStatus}
//         onClose={closeConfirm}
//         onSubmit={confirmToggle}
//         isLoader={isLoader}
//         headerTitle={"Update Status"}
//         title={
//           sportsListingUpdateId?.type === "matchOdds"
//             ? `You Want to ${sportsListingUpdateId?.status} Match Odds?`
//             : `You Want to ${sportsListingUpdateId?.status} This Match?`
//         }
//       />
//     </app-events>
//   );
// };

// export default MM;

// // <app-modal _ngcontent-serverapp-c117 _nghost-serverapp-c43>
// //     <div
// //       _ngcontent-serverapp-c43
// //       id="createModal"
// //       className="pop_bg"
// //       style={{ height: "100%", width: "100%", display: "none" }}
// //     >
// //       <div _ngcontent-serverapp-c43 className="pop_box pop_refer">
// //         <a _ngcontent-serverapp-c43 href="#" className="close_pop">
// //           close_pop
// //         </a>
// //         {/**/}
// //         <div _ngcontent-serverapp-c117 className="modal-header">
// //           <h3 _ngcontent-serverapp-c117>Sport Detail</h3>
// //         </div>
// //         <div _ngcontent-serverapp-c117 className="modal-content">
// //           <div _ngcontent-serverapp-c117 className="grid grid-col-2">
// //             <input
// //               _ngcontent-serverapp-c117
// //               type="text"
// //               className="input"
// //               placeholder="Sport Name"
// //             />
// //             <input
// //               _ngcontent-serverapp-c117
// //               type="file"
// //               className="input"
// //             />
// //             <input
// //               _ngcontent-serverapp-c117
// //               type="text"
// //               className="input"
// //               placeholder="Betfair ID"
// //             />
// //           </div>
// //           <div _ngcontent-serverapp-c117 className="form-group">
// //             <input
// //               _ngcontent-serverapp-c117
// //               type="checkbox"
// //               name="active"
// //               id="active"
// //             />{" "}
// //             Is Active{" "}
// //           </div>
// //         </div>
// //         <div _ngcontent-serverapp-c117 className="modal-footer">
// //           <button _ngcontent-serverapp-c117 className="btn-send">
// //             Save
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   </app-modal>
// //   <app-modal _ngcontent-serverapp-c117 _nghost-serverapp-c43>
// //     <div
// //       _ngcontent-serverapp-c43
// //       id="createModal"
// //       className="pop_bg"
// //       style={{ height: "100%", width: "100%", display: "none" }}
// //     >
// //       <div _ngcontent-serverapp-c43 className="pop_box pop_refer">
// //         <a _ngcontent-serverapp-c43 href="#" className="close_pop">
// //           close_pop
// //         </a>
// //         {/**/}
// //         <div _ngcontent-serverapp-c117 className="modal-header">
// //           <h3 _ngcontent-serverapp-c117>Tournament Detail</h3>
// //         </div>
// //         <div _ngcontent-serverapp-c117 className="modal-content">
// //           <div _ngcontent-serverapp-c117 className="grid grid-col-2">
// //             <select _ngcontent-serverapp-c117 name="sport" id="sport">
// //               <option _ngcontent-serverapp-c117 value>
// //                 {" "}
// //                 Select Sport
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="cricket">
// //                 {" "}
// //                 Cricket
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="soccer">
// //                 Soccer
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="tennis">
// //                 Tennis
// //               </option>
// //             </select>
// //             <input
// //               _ngcontent-serverapp-c117
// //               type="text"
// //               className="input"
// //               placeholder="Tournament Name"
// //             />
// //             <input
// //               _ngcontent-serverapp-c117
// //               type="text"
// //               className="input"
// //               placeholder="Betfair ID"
// //             />
// //           </div>
// //           <div _ngcontent-serverapp-c117 className="form-group">
// //             <input
// //               _ngcontent-serverapp-c117
// //               type="checkbox"
// //               name="active"
// //               id="active"
// //             />{" "}
// //             Is Active{" "}
// //           </div>
// //         </div>
// //         <div _ngcontent-serverapp-c117 className="modal-footer">
// //           <button _ngcontent-serverapp-c117 className="btn-send">
// //             Save
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   </app-modal>
// //   <app-modal _ngcontent-serverapp-c117 _nghost-serverapp-c43>
// //     <div
// //       _ngcontent-serverapp-c43
// //       id="createModal"
// //       className="pop_bg"
// //       style={{ height: "100%", width: "100%", display: "none" }}
// //     >
// //       <div _ngcontent-serverapp-c43 className="pop_box pop_refer">
// //         <a _ngcontent-serverapp-c43 href="#" className="close_pop">
// //           close_pop
// //         </a>
// //         {/**/}
// //         <div _ngcontent-serverapp-c117 className="modal-header">
// //           <h3 _ngcontent-serverapp-c117>Match Detail</h3>
// //         </div>
// //         <div _ngcontent-serverapp-c117 className="modal-content">
// //           <div _ngcontent-serverapp-c117 className="grid grid-col-2">
// //             <select _ngcontent-serverapp-c117 name="sport" id="sport">
// //               <option _ngcontent-serverapp-c117 value>
// //                 Select Sport
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="cricket">
// //                 {" "}
// //                 Cricket
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="soccer">
// //                 Soccer
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="tennis">
// //                 Tennis
// //               </option>
// //             </select>
// //             <select
// //               _ngcontent-serverapp-c117
// //               name="tournament"
// //               id="tournament"
// //             >
// //               <option _ngcontent-serverapp-c117 value>
// //                 Select Tournament
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="ipl">
// //                 Indian Premier League
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="soccer">
// //                 Australian Women's Cup
// //               </option>
// //             </select>
// //             <input
// //               _ngcontent-serverapp-c117
// //               type="text"
// //               className="input"
// //               placeholder="Match name"
// //             />
// //             <input
// //               _ngcontent-serverapp-c117
// //               type="text"
// //               className="input"
// //               placeholder="Betfair ID"
// //             />
// //             <div _ngcontent-serverapp-c117>
// //               <input
// //                 _ngcontent-serverapp-c117
// //                 type="text"
// //                 placeholder="YYYY-MM-DD"
// //                 autoComplete="off"
// //                 className="cal-input ng-untouched ng-valid ng-dirty"
// //               />
// //               <dp-date-picker className="dp-material">
// //                 <div>
// //                   <div
// //                     className="dp-input-container"
// //                     hidden
// //                     data-hidden="true"
// //                   >
// //                     <input
// //                       type="text"
// //                       className="dp-picker-input ng-untouched ng-pristine ng-valid"
// //                       placeholder
// //                     />
// //                   </div>
// //                 </div>
// //                 <div>
// //                   <div
// //                     className="dp-material dp-popup"
// //                     hidden
// //                     data-hidden="true"
// //                   >
// //                     <dp-day-calendar className="dp-material ng-untouched ng-valid ng-dirty">
// //                       <div className="dp-day-calendar-container">
// //                         <dp-calendar-nav className="dp-material">
// //                           <div className="dp-calendar-nav-container">
// //                             <div className="dp-nav-header">
// //                               <span hidden data-hidden="true">
// //                                 Sep, 2026
// //                               </span>
// //                               <button
// //                                 type="button"
// //                                 className="dp-nav-header-btn"
// //                                 data-hidden="false"
// //                               >
// //                                 Sep, 2026
// //                               </button>
// //                             </div>
// //                             <div className="dp-nav-btns-container">
// //                               <div className="dp-calendar-nav-container-left">
// //                                 {/**/}
// //                                 <button
// //                                   type="button"
// //                                   className="dp-calendar-nav-left"
// //                                   data-hidden="false"
// //                                 />
// //                               </div>
// //                               <button
// //                                 type="button"
// //                                 className="dp-current-location-btn"
// //                               />
// //                               {/**/}
// //                               <div className="dp-calendar-nav-container-right">
// //                                 <button
// //                                   type="button"
// //                                   className="dp-calendar-nav-right"
// //                                   data-hidden="false"
// //                                 />
// //                                 {/**/}
// //                               </div>
// //                             </div>
// //                           </div>
// //                         </dp-calendar-nav>
// //                         <div className="dp-calendar-wrapper">
// //                           <div className="dp-weekdays">
// //                             <span className="dp-calendar-weekday">Sun</span>
// //                             <span className="dp-calendar-weekday">Mon</span>
// //                             <span className="dp-calendar-weekday">Tue</span>
// //                             <span className="dp-calendar-weekday">Wed</span>
// //                             <span className="dp-calendar-weekday">Thu</span>
// //                             <span className="dp-calendar-weekday">Fri</span>
// //                             <span className="dp-calendar-weekday">Sat</span>
// //                             {/**/}
// //                           </div>
// //                           <div className="dp-calendar-week">
// //                             {/**/}
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-prev-month"
// //                               data-date="2026-08-30"
// //                             >
// //                               30
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-prev-month"
// //                               data-date="2026-08-31"
// //                             >
// //                               31
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-01"
// //                             >
// //                               01
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-02"
// //                             >
// //                               02
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-03"
// //                             >
// //                               03
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month dp-current-day"
// //                               data-date="2026-09-04"
// //                             >
// //                               04
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-05"
// //                             >
// //                               05
// //                             </button>
// //                             {/**/}
// //                           </div>
// //                           <div className="dp-calendar-week">
// //                             {/**/}
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-06"
// //                             >
// //                               06
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-07"
// //                             >
// //                               07
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-08"
// //                             >
// //                               08
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-09"
// //                             >
// //                               09
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-10"
// //                             >
// //                               10
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-11"
// //                             >
// //                               11
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-12"
// //                             >
// //                               12
// //                             </button>
// //                             {/**/}
// //                           </div>
// //                           <div className="dp-calendar-week">
// //                             {/**/}
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-13"
// //                             >
// //                               13
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-14"
// //                             >
// //                               14
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-15"
// //                             >
// //                               15
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-16"
// //                             >
// //                               16
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-17"
// //                             >
// //                               17
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-18"
// //                             >
// //                               18
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-19"
// //                             >
// //                               19
// //                             </button>
// //                             {/**/}
// //                           </div>
// //                           <div className="dp-calendar-week">
// //                             {/**/}
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-20"
// //                             >
// //                               20
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-21"
// //                             >
// //                               21
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-22"
// //                             >
// //                               22
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-23"
// //                             >
// //                               23
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-24"
// //                             >
// //                               24
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-25"
// //                             >
// //                               25
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-26"
// //                             >
// //                               26
// //                             </button>
// //                             {/**/}
// //                           </div>
// //                           <div className="dp-calendar-week">
// //                             {/**/}
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-27"
// //                             >
// //                               27
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-28"
// //                             >
// //                               28
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-29"
// //                             >
// //                               29
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-current-month"
// //                               data-date="2026-09-30"
// //                             >
// //                               30
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-next-month"
// //                               data-date="2026-10-01"
// //                             >
// //                               01
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-next-month"
// //                               data-date="2026-10-02"
// //                             >
// //                               02
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-next-month"
// //                               data-date="2026-10-03"
// //                             >
// //                               03
// //                             </button>
// //                             {/**/}
// //                           </div>
// //                           <div className="dp-calendar-week">
// //                             {/**/}
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-next-month"
// //                               data-date="2026-10-04"
// //                             >
// //                               04
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-next-month"
// //                               data-date="2026-10-05"
// //                             >
// //                               05
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-next-month"
// //                               data-date="2026-10-06"
// //                             >
// //                               06
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-next-month"
// //                               data-date="2026-10-07"
// //                             >
// //                               07
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-next-month"
// //                               data-date="2026-10-08"
// //                             >
// //                               08
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-next-month"
// //                               data-date="2026-10-09"
// //                             >
// //                               09
// //                             </button>
// //                             <button
// //                               type="button"
// //                               className="dp-calendar-day dp-next-month"
// //                               data-date="2026-10-10"
// //                             >
// //                               10
// //                             </button>
// //                             {/**/}
// //                           </div>
// //                           {/**/}
// //                         </div>
// //                       </div>
// //                       {/**/}
// //                       {/**/}
// //                     </dp-day-calendar>
// //                     {/**/}
// //                     {/**/}
// //                     {/**/}
// //                     {/**/}
// //                   </div>
// //                 </div>
// //               </dp-date-picker>
// //               {/**/}
// //             </div>
// //             <select _ngcontent-serverapp-c117 name="status" id="status">
// //               <option _ngcontent-serverapp-c117 value>
// //                 Select Status
// //               </option>
// //               <option _ngcontent-serverapp-c117 value={1}>
// //                 open
// //               </option>
// //               <option _ngcontent-serverapp-c117 value={2}>
// //                 Closed
// //               </option>
// //               <option _ngcontent-serverapp-c117 value={3}>
// //                 Settled
// //               </option>
// //               <option _ngcontent-serverapp-c117 value={4}>
// //                 Inactive
// //               </option>
// //             </select>
// //           </div>
// //           <div _ngcontent-serverapp-c117 className="form-group">
// //             <input
// //               _ngcontent-serverapp-c117
// //               type="checkbox"
// //               name="active"
// //               id="active"
// //             />{" "}
// //             Is Active{" "}
// //           </div>
// //         </div>
// //         <div _ngcontent-serverapp-c117 className="modal-footer">
// //           <button _ngcontent-serverapp-c117 className="btn-send">
// //             Save
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   </app-modal>
// //   <app-modal _ngcontent-serverapp-c117 _nghost-serverapp-c43>
// //     <div
// //       _ngcontent-serverapp-c43
// //       id="createModal"
// //       className="pop_bg"
// //       style={{ height: "100%", width: "100%", display: "none" }}
// //     >
// //       <div _ngcontent-serverapp-c43 className="pop_box pop_refer">
// //         <a _ngcontent-serverapp-c43 href="#" className="close_pop">
// //           close_pop
// //         </a>
// //         {/**/}
// //         <div _ngcontent-serverapp-c117 className="modal-header">
// //           <h3 _ngcontent-serverapp-c117>Bet Detail</h3>
// //         </div>
// //         <div _ngcontent-serverapp-c117 className="modal-content">
// //           <div _ngcontent-serverapp-c117 className="grid grid-col-2">
// //             <select _ngcontent-serverapp-c117 name="sport" id="sport">
// //               <option _ngcontent-serverapp-c117 value>
// //                 Select Sport
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="cricket">
// //                 {" "}
// //                 Cricket
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="soccer">
// //                 Soccer
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="tennis">
// //                 Tennis
// //               </option>
// //             </select>
// //             <select
// //               _ngcontent-serverapp-c117
// //               name="tournament"
// //               id="tournament"
// //             >
// //               <option _ngcontent-serverapp-c117 value>
// //                 Select Tournament
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="ipl">
// //                 Indian Premier League
// //               </option>
// //               <option _ngcontent-serverapp-c117 value="soccer">
// //                 Australian Women's Cup
// //               </option>
// //             </select>
// //             <select _ngcontent-serverapp-c117 name="match" id="match">
// //               <option _ngcontent-serverapp-c117 value>
// //                 Select Match
// //               </option>
// //               <option _ngcontent-serverapp-c117 value={1}>
// //                 Sri Lanka v Bangladesh
// //               </option>
// //               <option _ngcontent-serverapp-c117 value={2}>
// //                 Australia v India
// //               </option>
// //               <option _ngcontent-serverapp-c117 value={3}>
// //                 India v Sri Lanka
// //               </option>
// //             </select>
// //             <input
// //               _ngcontent-serverapp-c117
// //               type="text"
// //               placeholder="Bet Name"
// //             />
// //             <input
// //               _ngcontent-serverapp-c117
// //               type="text"
// //               placeholder="Betfair ID"
// //             />
// //           </div>
// //           <div _ngcontent-serverapp-c117 className="form-group">
// //             <input _ngcontent-serverapp-c117 type="checkbox" /> Is Active
// //           </div>
// //           <div _ngcontent-serverapp-c117 className="form-group">
// //             <input _ngcontent-serverapp-c117 type="checkbox" /> Is Bit Allow
// //           </div>
// //           <div _ngcontent-serverapp-c117 className="form-group">
// //             <input _ngcontent-serverapp-c117 type="checkbox" /> Is Allow
// //             Limit
// //           </div>
// //         </div>
// //         <div _ngcontent-serverapp-c117 className="modal-footer">
// //           <button _ngcontent-serverapp-c117 className="btn-send">
// //             Save
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   </app-modal>
// //   <app-modal _ngcontent-serverapp-c117 _nghost-serverapp-c43>
// //     <div
// //       _ngcontent-serverapp-c43
// //       id="createModal"
// //       className="pop_bg"
// //       style={{ height: "100%", width: "100%", display: "none" }}
// //     >
// //       <div _ngcontent-serverapp-c43 className="pop_box pop_refer">
// //         <a _ngcontent-serverapp-c43 href="#" className="close_pop">
// //           close_pop
// //         </a>
// //         {/**/}
// //         <div _ngcontent-serverapp-c117 className="modal-header">
// //           <h2 _ngcontent-serverapp-c117>Set Liquidity </h2>
// //         </div>
// //         <div _ngcontent-serverapp-c117 className="modal-content">
// //           {/**/}
// //           <div _ngcontent-serverapp-c117 className="modal-footer">
// //             <button _ngcontent-serverapp-c117 className="btn btn-secondary">
// //               Save
// //             </button>
// //             <button _ngcontent-serverapp-c117 className="btn btn-secondary">
// //               Cancel
// //             </button>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   </app-modal>


import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { apiGet, apiPost, apiPut } from "../Utils/apiFetch";
import { apiPath } from "../Utils/apiPath";
import { formatDate } from "../Utils/Constant";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import UpdateDialogBox from "./User/UpdateDialogBox";
import Pagination from "../components/Pagination";
import { startCase } from "lodash";

const SPORT_OPTIONS = [
  { id: "All", value: "all", label: "All" },
  { id: "events_1", value: 1, label: "Soccer" },
  { id: "events_2", value: 2, label: "Tennis" },
  { id: "events_4", value: 4, label: "Cricket" },
];

const TABS = [
  { id: "reportType_sportsBook", label: "Import", status: "import" },
  { id: "reportType_exchange", label: "Inplay", status: "in_play" },
  { id: "reportType_casino", label: "Upcoming", status: "active" },
];

const GAME_TYPE_BY_EVENT = { 1: "soccer", 2: "tennis", 4: "cricket" };

const LISTING_FIELDS = [
  { field: "matchOdds", label: "Match Odds" },
  { field: "bookMaker", label: "Book Maker" },
  { field: "fancy", label: "Fancy" },
  { field: "premiumFancy", label: "Premium Fancy" },
];

const Switch = ({ checked, disabled, onClick }) => (
  <label className="xyz">
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      readOnly
      onClick={disabled ? undefined : onClick}
    />
    <span className="slider round" />
  </label>
);

const MM = () => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);

  const [tab, setTab] = useState("in_play");
  const [filter, setFilter] = useState({ eventType: "all", status: "in_play" });
  const [keyword, setKeyword] = useState("");
  const [openMarketId, setOpenMarketId] = useState("");

  const [blockMatchStatus, setBlockMatchStatus] = useState(false);
  const [sportsListingUpdateId, setSportsListingUpdateId] = useState({});
  const [isLoader, setLoader] = useState(false);

  // series listing (all tabs)
  const [matchData, setMatchData] = useState({});
  const [key, setKey] = useState("");

  // same API as old project's BlockMarket page; Import lists "suspended" matches
  const getMatchData = async (finalFilter, page = 1, keepOpen = false) => {
    const search_params = {
      page,
     limit: 10,
      status:
        finalFilter.status === "import" ? "suspended" : finalFilter.status,
    };
    search_params.gameType =
      GAME_TYPE_BY_EVENT[finalFilter.eventType] || "all";
    if (keyword) search_params.keyword = keyword;

    const { status, data: response_users } = await apiGet(
      apiPath.blockmarketList,
      search_params,
    );
    if (status === 200) {
      if (response_users.success) {
        setMatchData(response_users.results || {});
        if (!keepOpen) setKey("");
      }
    }
  };

  // keepOpen: refresh without collapsing expanded rows (used after a status change)
  const getData = (overrideFilter, page = 1, keepOpen = false) =>
    getMatchData(overrideFilter || filter, page, keepOpen);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabChange = (tabDef) => {
    setTab(tabDef.status);
    const nextFilter = { ...filter, status: tabDef.status };
    setFilter(nextFilter);
    getData(nextFilter);
  };

  const handleSportChange = (value) => {
    const nextFilter = { ...filter, eventType: value };
    setFilter(nextFilter);
    getData(nextFilter);
  };

  const toggleMarket = (marketId) =>
    setOpenMarketId((prev) => (prev === marketId ? "" : marketId));

  // match odds, keyed by eventId
  const [runnerOdds, setRunnerOdds] = useState({});

  const getMatchOdds = async (item) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getMatchOdds +
        `?marketId=${item?.marketId}&eventId=${item?.eventId}`,
    );
    if (status === 200 && response_users.success) {
      const socket_data = response_users?.results;
      const rt =
        socket_data?.eventId == item?.eventId ? socket_data?.rt || [] : [];
      setRunnerOdds((prev) => ({
        ...prev,
        [item?.eventId]: {
          back: rt.filter((o) => o.ib),
          lay: rt.filter((o) => !o.ib),
        },
      }));
    }
  };

  // Import tab: flat match list (no series dropdown)
  const isImport = tab === "import";
  const importMatches = isImport
    ? (matchData?.data || []).flatMap((series) =>
        (series?.matchList || []).map((item) => ({ series, item })),
      )
    : [];

  // poll odds every 5s only while both the series and the match dropdown
  // are open (Inplay / Upcoming) and the match has runners
  const openMatch =
    !isImport && openMarketId && key !== ""
      ? matchData?.data?.[key]?.matchList?.find(
          (m) => `${m?.eventId}_0` === openMarketId,
        )
      : null;
  const hasRunners = openMatch?.runners?.length > 0;

  useEffect(() => {
    if (!openMatch || !hasRunners) return;
    getMatchOdds(openMatch);
    const timer = setInterval(() => getMatchOdds(openMatch), 5000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openMatch?.eventId, openMatch?.marketId, hasRunners]);

  // old BlockMarket game listing toggle: by seriesId (series row) or eventId (match row)
  const openGameListingConfirm = (idKey, idValue, field, current, extra = {}) => {
    const next = current === "on" ? "off" : "on";
    // match status is turned off as "suspended" rather than "off"
    const apiValue = field === "match" && next === "off" ? "off" : next;
    setSportsListingUpdateId({
      type: "gameListing",
      payload: { [idKey]: idValue, ...extra, [field]: apiValue },
      status: next === "on" ? "On" : "Off",
    });
    setBlockMatchStatus(true);
  };

  // Import tab: always sets match to "on" (imports the match)
  const openImportConfirm = (item) => {
    setSportsListingUpdateId({
      type: "gameListing",
      payload: { eventId: item?.eventId, marketId: item?.marketId, match: "on" },
      status: "On",
    });
    setBlockMatchStatus(true);
  };

  const closeConfirm = () => {
    setBlockMatchStatus(false);
    setSportsListingUpdateId({});
  };
  const confirmToggle = async () => {
    setLoader(true);
    try {
      const updateType = sportsListingUpdateId?.type;
      if (updateType === "gameListing") {
        const { status, data: response_users } = await apiPost(
          apiPath.updateBlockListinStatus,
          sportsListingUpdateId?.payload,
        );
        if (status === 200 && response_users.success) {
          toast.success(response_users.message);
          getData(undefined, matchData?.page || 1, true);
        } else {
          toast.error(response_users.message);
        }
        return;
      }
      const path =
        updateType === "match"
          ? apiPath.updateSportsListingStatus + `/${sportsListingUpdateId?.id}`
          : updateType === "matchOnOff"
            ? apiPath.updateMatchOddsListingStatus
            : apiPath.updateBlockListinStatus;
      const payload =
        updateType === "matchOnOff"
          ? {
              eventId: sportsListingUpdateId?.eventId,
              marketId: sportsListingUpdateId?.marketId,
              status: sportsListingUpdateId?.status,
            }
          : updateType === "match"
            ? { status: sportsListingUpdateId?.status }
            : {
                eventId: sportsListingUpdateId?.eventId,
                matchOdds: sportsListingUpdateId?.matchOdds,
                marketId: sportsListingUpdateId?.marketId,
              };

      const { status, data: response_users } = await (
        updateType === "matchOdds" ? apiPost(path, payload) : apiPut(path, payload)
      );


      if (status === 200 && response_users.success) {
        toast.success(response_users.message);
        getData(undefined, matchData?.page || 1, true);
      } else {
        toast.error(response_users.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setLoader(false);
      closeConfirm();
    }
  };


  return (
    <app-events>
      <div style={{ width: "99%" }} className="main_wrap">
        <ul className="report-tab-wrap" style={{ display: "flex" }}>
          {TABS.map((t) => (
            <li
              key={t.id}
              id={t.id}
              className={`report-tab ${tab === t.status ? "select" : ""}`}
              onClick={() => handleTabChange(t)}
              style={{ cursor: "pointer" }}
            >
              {" "}
              {t.label}{" "}
            </li>
          ))}
          <li className="spacer" />
          <li className="web users-info">
            <span> Online Users 0 </span>
            <span className="separator"> | </span>
            <span> Total Users: 0 </span>
          </li>
        </ul>
        <div className="function-wrap">
          <ul className="input-list contentclass">
            <li id="eventRadioBtnList" className="eventRadioBtnList">
              {SPORT_OPTIONS.map((opt) => (
                <React.Fragment key={opt.id}>
                  <input
                    type="radio"
                    name="events"
                    id={opt.id}
                    checked={filter.eventType === opt.value}
                    onChange={() => handleSportChange(opt.value)}
                  />
                  <label htmlFor={opt.id}>{opt.label}</label>
                </React.Fragment>
              ))}
            </li>
            <li>
              <div id="userSearchUl" className="search-wrap">
                <input
                  type="text"
                  name="userId"
                  id="userId"
                  className="search-input"
                  placeholder="Search Events, Tournaments"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                />
                <button
                  id="searchUserId"
                  className="search-but"
                  onClick={() => getData()}
                >
                  {" "}
                  Search{" "}
                </button>
              </div>
            </li>
            <li className="spacer" />
            <li className="import-button">
              <button className="btn-send" onClick={() => getData()}>
                Refresh
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div style={{ width: "99%" }} className="main_wrap">
        <div className="table-responsive data-table" />
        {isImport ? (
        <div className="table-responsive data-table">
          <table id="table_DL" className="table01 table-pt">
            <tbody>
              <tr id="head">
                <th width="6%" className="align-C">S.No.</th>
                <th width="10%" className="align-C">SportName</th>
                <th width="20%" className="align-L">Tournament</th>
                <th className="align-L">Matches</th>
                <th width="12%" className="align-C">Match Date</th>
                <th width="6%" className="align-C">Status</th>
                <th width="8%" className="align-C">BF status</th>
              </tr>
            </tbody>
            <tbody id="content">
              {importMatches.length > 0 ? (
                importMatches.map(({ series, item }, id) => (
                      <tr key={item?.eventId || id}>
                        <td className="align-C">{id + 1}</td>
                        <td className="align-C">
                          {startCase(series?.gameType)}
                        </td>
                        <td className="align-L">{series?.seriesName}</td>
                        <td className="align-L" title={item?.eventName}>
                          {item?.eventName}
                        </td>
                        <td className="align-C">
                          <span className="red">
                            {formatDate(item?.eventDateTime, user?.timeZone)}
                          </span>
                        </td>
                        <td className="align-C" title="Status">
                          <Switch
                            checked={item?.match === "on"}
                            onClick={() => openImportConfirm(item)}
                          />
                        </td>
                        <td className="align-C">{item?.status || "-"}</td>
                      </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7}>No records found</td>
                </tr>
              )}
            </tbody>
          </table>
          {matchData?.totalPages > 1 && (
            <Pagination
              pagination={matchData}
              onPageChange={(p) => getData(undefined, p)}
            />
          )}
        </div>
        ) : (
        <div className="table-responsive data-table">
          <table id="table_DL" className="table01 table-pt">
            <tbody>
              <tr id="head">
                <th width="6%" className="align-C">S.No.</th>
                <th className="align-L">Series Name</th>
                <th width="12%" className="align-C">Date</th>
                {LISTING_FIELDS.map((f) => (
                  <th key={f.field} width="10%" className="align-C">
                    {f.label}
                  </th>
                ))}
              </tr>
            </tbody>
            <tbody id="content">
              {matchData?.data?.length > 0 ? (
                matchData.data.map((series, index) => {
                  const isOpen = key === index;
                  return (
                    <React.Fragment key={series?.seriesId || index}>
                      <tr>
                        <td className="align-C">
                          <a
                            className={isOpen ? "expand-open" : "expand-close"}
                            style={{ cursor: "pointer", marginRight: "10px" }}
                            onClick={() => setKey(isOpen ? "" : index)}
                          />
                          {index + 1}
                        </td>
                        <td className="align-L">{series?.seriesName} - {startCase(series?.gameType)}</td>
                        <td className="align-C">
                          {formatDate(series?.updatedAt)}
                        </td>
                        {LISTING_FIELDS.map((f) => (
                          <td key={f.field} className="align-C">
                            <Switch
                              checked={series?.[f.field] === "on"}
                              disabled={!!series?.[`${f.field}UplineDisable`]}
                              onClick={() =>
                                openGameListingConfirm(
                                  "seriesId",
                                  series?.seriesId,
                                  f.field,
                                  series?.[f.field],
                                )
                              }
                            />
                          </td>
                        ))}
                      </tr>
                      {isOpen && (
                        <tr className="expand first">
                          <td colSpan={7}>
                            <table style={{marginBottom:"0"}} className="table01">
                              <tbody>
                                <tr>
                                  <th width="6%" className="align-C">S.No.</th>
                                  <th className="align-L">Match Name</th>
                                  <th width="5%" className="align-C">
                                    Status
                                  </th>
                                  {/* <th className="align-L">Market</th> */}
                                  <th width="5%" className="align-C">
                                    TV
                                  </th>
                                  <th width="5%" className="align-C">
                                    Time
                                  </th>
                                  <th width="8%" className="align-C">
                                    User Online
                                  </th>
                                  <th width="8%" className="align-C">
                                    No of bets
                                  </th>
                                  {LISTING_FIELDS.map((f) => (
                                    <th key={f.field} width="10%" className="align-C">
                                      {f.label}
                                    </th>
                                  ))}
                                </tr>
                                {series?.matchList?.length > 0 ? (
                                  series.matchList.map((item, id) => {
                                    const marketId = `${item?.eventId}_0`;
                                    const isMarketOpen = openMarketId === marketId;
                                    return (
                                    <React.Fragment key={item?.eventId || id}>
                                    <tr>
                                      <td className="align-C">{id + 1}</td>
                                      <td className="align-L">
                                        <a
                                          className={
                                            isMarketOpen ? "expand-open" : "expand-close"
                                          }
                                          style={{ cursor: "pointer" }}
                                          onClick={() => toggleMarket(marketId)}
                                        />{" "}
                                        {item?.eventName}
                                      </td>
                                      {/* <td className="align-L">{item?.market}</td> */}
                                      <td className="align-C" id={`status_${item?.eventId}`}>
                                        <Switch
                                          checked={item?.match === "on"}
                                          onClick={() =>
                                            openGameListingConfirm(
                                              "eventId",
                                              item?.eventId,
                                              "match",
                                              item?.match,
                                              { marketId: item?.marketId },
                                            )
                                          }
                                        />
                                      </td>
                                      <td className="align-C" id={`tv_${item?.eventId}`}>
                                        <span className="green">
                                          <i className="fa fa-television" />
                                        </span>
                                      </td>
                                      <td className="align-C" id={`time_${item?.eventId}`}>
                                        <span className="red">
                                          {formatDate(
                                            item?.eventDateTime,
                                            user?.timeZone,
                                          )}{" "}
                                        </span>
                                      </td>
                                      <td className="align-C" id={`user_online_${item?.eventId}`}>
                                        {" "}
                                        0{" "}
                                      </td>
                                      <td className="align-C" id={`no_bet_${item?.eventId}`}>
                                        {" "}
                                        0{" "}
                                      </td>
                                      {LISTING_FIELDS.map((f) => (
                                        <td key={f.field} className="align-C">
                                          <Switch
                                            checked={item?.[f.field] === "on"}
                                            disabled={!!item?.[`${f.field}UplineDisable`]}
                                            onClick={() =>
                                              openGameListingConfirm(
                                                "eventId",
                                                item?.eventId,
                                                f.field,
                                                item?.[f.field],
                                                { marketId: item?.marketId },
                                              )
                                            }
                                          />
                                        </td>
                                      ))}
                                    </tr>
                                    <tr
                                      className="expand first"
                                      style={{ display: isMarketOpen ? "table-row" : "none" }}
                                      id={`sub_${item?.eventId}`}
                                    >
                                      <td />
                                      <td colSpan={10}>
                                        <div
                                          className="markets"
                                          style={{ display: isMarketOpen ? "flex" : "none" }}
                                          id={`market_${item?.eventId}_0`}
                                        >
                                          {item?.runners?.length > 0 ? (
                                            item.runners.map((res, i) => {
                                              const odds = runnerOdds[item?.eventId];
                                              const back = odds?.back?.find(
                                                (o) => o.ri === res?.SelectionId,
                                              );
                                              const lay = odds?.lay?.find(
                                                (o) => o.ri === res?.SelectionId,
                                              );
                                              return (
                                              <div
                                                className="market sub_market"
                                                key={res?.SelectionId || i}
                                              >
                                                
                                                {res?.RunnerName} <span className="spacer" />
                                                <span className="odds-display">
                                                  <div
                                                    className="w-4/12 relative grid gap-0.5 grid-cols-2"
                                                    style={{
                                                      display: "flex",
                                                      marginRight: "10px",
                                                    }}
                                                  >
                                                    <div
                                                      title="back"
                                                      className="py-1.5 h-36px text-center bg-back-300 back-1 animate-spark-back"
                                                      style={{
                                                        backgroundColor: "#a7d8fd",
                                                        padding: "5px",
                                                        width: "50px",
                                                      }}
                                                    >
                                                      <span
                                                        className="text-15 pb-0.5"
                                                        style={{
                                                          paddingBottom: "0.125rem",
                                                          fontWeight: "600",
                                                        }}
                                                      >
                                                        {" "}
                                                        {back?.rt ?? "-"}
                                                      </span>
                                                      <p
                                                        className="text-9"
                                                        style={{
                                                          fontSize: ".6428571429rem",
                                                          marginBottom: "0px",
                                                        }}
                                                      >
                                                        {" "}
                                                        {back?.bv ?? "-"}{" "}
                                                      </p>
                                                    </div>
                                                    <div
                                                      title="back"
                                                      className="py-1.5 h-36px text-center bg-back-300 back-1 animate-spark-back"
                                                      style={{
                                                        backgroundColor: "#f9c9d4",
                                                        padding: "5px",
                                                        width: "50px",
                                                      }}
                                                    >
                                                      <span
                                                        className="text-15 pb-0.5"
                                                        style={{
                                                          paddingBottom: "0.125rem",
                                                          fontWeight: "600",
                                                        }}
                                                      >
                                                        {" "}
                                                        {lay?.rt ?? "-"}
                                                      </span>
                                                      <p
                                                        className="text-9"
                                                        style={{
                                                          fontSize: ".6428571429rem",
                                                          marginBottom: "0px",
                                                        }}
                                                      >
                                                        {" "}
                                                        {lay?.bv ?? "-"}{" "}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </span>
                                                <button className="btn">
                                                  <i
                                                    aria-hidden="true"
                                                    className="fa fa-plus-circle"
                                                  />
                                                </button>
                                              </div>
                                              );
                                            })
                                          ) : (
                                            <div className="market sub_market">
                                              No selections found
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                    </React.Fragment>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td colSpan={11}>No records found</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={7}>No records found</td>
                </tr>
              )}
            </tbody>
          </table>
          {matchData?.totalPages > 1 && (
            <Pagination
              pagination={matchData}
              onPageChange={(p) => getData(undefined, p)}
            />
          )}
        </div>
        )}
        <div className="table-responsive data-table" />
        <div className="table-responsive data-table" />
      </div>

      <UpdateDialogBox
        open={blockMatchStatus}
        onClose={closeConfirm}
        onSubmit={confirmToggle}
        isLoader={isLoader}
        headerTitle={"Update Status"}
        title={
          sportsListingUpdateId?.type === "gameListing"
            ? `You Want to ${sportsListingUpdateId?.status} This Match?`
            : sportsListingUpdateId?.type === "matchOdds"
            ? `You Want to ${sportsListingUpdateId?.status} Match Odds?`
            : `You Want to ${sportsListingUpdateId?.status} This Match?`
        }
      />
    </app-events>
  );
};

export default MM;